




































import { defineComponent } from '@nuxtjs/composition-api';
import { mediaUrlFallback } from '~/helpers/utils';
import useWindowResize from '~/hooks/useResizeWindow';
import useUrlFormatter from '~/hooks/useUrlFormatter';
import usePromotionsDrawer from '~/hooks/usePromotionsDrawer';

export default defineComponent({
  name: 'Promotion',
  props: {
    promotion: {
      type: Object,
      default: {}
    }
  },
  setup(props) {
    const { isDesktop } = useWindowResize();
    const formatUrl = useUrlFormatter();
    const { openPromotionsDrawer } = usePromotionsDrawer();

    const mediaUrl = (url: string): string => {
      return mediaUrlFallback(url);
    };

    const handlePromotionClick = () => {
      openPromotionsDrawer(props.promotion);
    };

    return {
      isDesktop,
      mediaUrl,
      formatUrl,
      handlePromotionClick
    };
  }
});
